import { render, staticRenderFns } from "./verifycodesetting.vue?vue&type=template&id=a48e09ee"
import script from "./verifycodesetting.vue?vue&type=script&lang=js"
export * from "./verifycodesetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports